(() => {
  const families = ['all', 'fresh', 'soft', 'woody', 'warm', 'dark'];
  const aliases = { clean: 'fresh', floral: 'soft', evening: 'dark' };
  const familyOf = value => families.includes(aliases[value] || value) ? aliases[value] || value : 'all';
  const plainClick = (event, link) => !event.defaultPrevented && event.button === 0 &&
    !event.metaKey && !event.ctrlKey && !event.shiftKey && !event.altKey &&
    !link.hasAttribute('download') && (!link.target || link.target === '_self');
  const serverKey = value => {
    const url = new URL(value); url.hash = '';
    ['match', 'section_id'].forEach(key => url.searchParams.delete(key));
    url.searchParams.sort(); return url.href;
  };
  const directionURL = (current, family, collectionPath) => {
    const url = new URL(current);
    if (collectionPath) {
      url.pathname = collectionPath;
      [...url.searchParams.keys()].filter(key => key.startsWith('filter.') || key === 'page').forEach(key => url.searchParams.delete(key));
    }
    ['match', 'scent', 'order', 'available', 'section_id'].forEach(key => url.searchParams.delete(key));
    if (family !== 'all') url.searchParams.set('match', family);
    url.hash = collectionPath ? 'ps-collection-results' : 'find-your-scent';
    return url;
  };
  if (typeof module !== 'undefined' && module.exports) module.exports = {familyOf, plainClick, serverKey, directionURL};
  if (typeof document === 'undefined') return;

  const rootPath = globalThis.Shopify?.routes?.root || '/';
  let collection = document.querySelector('[data-ps-collection-url]')?.closest('.shopify-section');
  let renderedURL = new URL(location.href), request, revision = 0;
  const syncNavigation = () => {
    const family = familyOf(new URL(location.href).searchParams.get('match'));
    document.querySelectorAll('.ps-shop-directions a').forEach(link => {
      const candidate = new URL(link.href).searchParams.get('match');
      const active = candidate ? familyOf(candidate) === family : family === 'all' &&
        collection?.querySelector('[data-ps-collection-url]')?.dataset.psCollectionUrl === location.pathname;
      if (active) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current');
    });
  };
  const scrollToResults = target => {
    if (!target) return;
    target.scrollIntoView({block:'start', behavior:matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'});
  };
  const applyCollection = () => {
    const grid = collection?.querySelector('product-list[data-ps-complete="true"]');
    syncNavigation();
    if (!grid) return;
    const family = familyOf(new URL(location.href).searchParams.get('match'));
    const cards = [...grid.querySelectorAll(':scope > product-card[data-scent-family]')];
    cards.forEach(card => { card.hidden = family !== 'all' && card.dataset.scentFamily !== family; });
    grid.querySelectorAll(':scope > .product-list__promo').forEach(promo => { promo.hidden = family !== 'all'; });
    const count = cards.filter(card => !card.hidden).length;
    const counter = collection.querySelector('.ps-results-count');
    if (counter) counter.textContent = `${count} fragrance${count === 1 ? '' : 's'}`;
    const feedback = collection.querySelector('[data-category-feedback]');
    if (feedback) {
      feedback.hidden = family === 'all';
      feedback.querySelector('[data-category-message]').textContent = count ? '' : 'No fragrances in this scent direction match your filters.';
    }
  };
  const commit = (url, push) => {
    if (push && url.href !== location.href) history.pushState(history.state, '', url);
  };
  const renderCollection = async (url, {push = true, scroll = true} = {}) => {
    request?.abort(); const sequence = ++revision;
    // Drawers are temporarily moved to body. Let them return before replacing results.
    const dialogs = [...document.querySelectorAll('facets-drawer[open],facets-sort-popover[open]')];
    if (dialogs.length) await Promise.all(dialogs.map(dialog => dialog.hide?.()));
    if (sequence !== revision) return;
    if (serverKey(url.href) === serverKey(renderedURL.href)) {
      collection.removeAttribute('aria-busy');
      collection.querySelector('[data-category-retry]')?.remove();
      commit(url, push); applyCollection();
      if (scroll) scrollToResults(collection.querySelector('.collection'));
      return;
    }
    request = new AbortController();
    collection.setAttribute('aria-busy', 'true');
    const fetchURL = new URL(url); fetchURL.hash = '';
    fetchURL.searchParams.set('section_id', collection.id.replace(/^shopify-section-/, ''));
    try {
      const response = await fetch(fetchURL, {credentials:'same-origin', signal:request.signal});
      if (!response.ok) throw new Error('Collection unavailable');
      const page = new DOMParser().parseFromString(await response.text(), 'text/html');
      const next = page.getElementById(collection.id);
      if (!next?.querySelector('[data-ps-collection-url]')) throw new Error('Collection missing');
      if (sequence !== revision) return;
      // Existing custom elements reconnect; the header, footer and shortlist stay mounted.
      const focusedId = document.activeElement?.id;
      const focusedControl = document.activeElement?.getAttribute('aria-controls');
      collection.replaceChildren(...document.importNode(next, true).childNodes);
      renderedURL = new URL(url); commit(url, push); applyCollection();
      const focus = focusedId ? document.getElementById(focusedId) :
        [...collection.querySelectorAll('button[aria-controls]')].find(button => button.getAttribute('aria-controls') === focusedControl);
      focus?.focus({preventScroll:true});
      const alert = document.getElementById('error-announcement'); if (alert) alert.textContent = '';
      if (scroll) scrollToResults(collection.querySelector('.collection'));
    } catch (error) {
      if (error.name === 'AbortError' || sequence !== revision) return;
      const alert = document.getElementById('error-announcement');
      if (alert) alert.textContent = 'The fragrances could not be updated. Please try again.';
      // Keep the current products usable and offer an ordinary navigation fallback.
      let retry = collection.querySelector('[data-category-retry]');
      if (!retry) { retry = document.createElement('a'); retry.dataset.categoryRetry = ''; retry.className = 'ps-category-retry'; collection.prepend(retry); }
      retry.href = url.href; retry.textContent = 'Reload these fragrance results';
      if (!push) history.replaceState(history.state, '', renderedURL);
    } finally {
      if (sequence === revision) collection.removeAttribute('aria-busy');
    }
  };
  document.addEventListener('click', event => {
    const clear = event.target.closest('[data-clear-category]');
    const link = event.target.closest('a[href]');
    if (clear && collection) {
      const url = new URL(location.href); url.searchParams.delete('match');
      renderCollection(url); return;
    }
    if (!link || !plainClick(event, link)) return;
    const target = new URL(link.href);
    if (target.origin !== location.origin) return;
    const isDirection = target.pathname === rootPath && target.hash === '#find-your-scent' && target.searchParams.has('match') &&
      families.includes(aliases[target.searchParams.get('match')] || target.searchParams.get('match'));
    const isShopAll = link.closest('.ps-shop-directions') && target.pathname === `${rootPath}collections/fragrances` && !target.search;
    const finder = document.querySelector('ps-discovery');
    if (finder?.ready && isDirection) {
      event.preventDefault();
      const family = familyOf(target.searchParams.get('match'));
      const url = directionURL(location.href, family);
      commit(url, true); finder.restore();
      if (finder.filters) finder.filters.open = false;
      syncNavigation(); scrollToResults(document.getElementById('find-your-scent'));
    } else if (collection && (isDirection || isShopAll)) {
      const grid = collection.querySelector('product-list');
      // Never filter a single page as though it were the full catalog.
      if (grid && grid.dataset.psComplete !== 'true') return;
      event.preventDefault();
      const url = directionURL(location.href, isShopAll ? 'all' : familyOf(target.searchParams.get('match')), `${rootPath}collections/fragrances`);
      renderCollection(url);
    } else if (collection && link.matches('.ps-collection-tag-filter,.ps-active-tag-facet,.ps-active-tag-facets__clear')) {
      const base = collection.querySelector('[data-ps-collection-url]').dataset.psCollectionUrl;
      // Same-collection tags update the results without restarting the page.
      if (target.pathname !== base && !target.pathname.startsWith(`${base}/`)) return;
      event.preventDefault();
      ['preview_theme_id', '_fd', 'pb'].forEach(key => { const value = new URL(location.href).searchParams.get(key); if(value)target.searchParams.set(key,value); });
      renderCollection(target);
    }
  });
  // Use one rendering path for native price, availability, sorting and pagination.
  // This also restores results, not just the URL, when the shopper presses Back.
  document.addEventListener('facet:update', event => {
    if (!collection || event.detail.url.searchParams.get('section_id') !== collection.id.replace(/^shopify-section-/, '')) return;
    event.stopImmediatePropagation();
    const url = new URL(event.detail.url); url.searchParams.delete('section_id');
    const current = new URL(location.href);
    ['match', 'preview_theme_id', '_fd', 'pb'].forEach(key => { if (!url.searchParams.has(key) && current.searchParams.has(key)) url.searchParams.set(key,current.searchParams.get(key)); });
    renderCollection(url);
  }, true);
  window.addEventListener('popstate', () => {
    if (collection) renderCollection(new URL(location.href), {push:false, scroll:false});
    else syncNavigation();
  });
  // Finder buttons update the URL too; keep the top navigation in sync.
  document.addEventListener('click', event => { if (event.target.closest('ps-discovery')) syncNavigation(); });
  document.addEventListener('input', event => { if (event.target.closest('ps-discovery')) syncNavigation(); });
  applyCollection();
})();
